export default {"src":"/_next/static/media/staysure-bcuk-white.033d0c7e.svg","height":34,"width":140,"blurWidth":0,"blurHeight":0};